module.exports = "https://web-assets-production.autolist.com/_next/static/images/content-promo-large-21e1c8ab39033862dcb3b34a6ca23f74.svg";